import { ColGroupDef } from 'ag-grid-community'
import { intl } from '../../../../../../i18n'
import { ProgramManagementRow } from '../../../programManagement'
import { getAggregatedValue } from './aggregation'
import {
  RowValueGetter,
  isProcessRow,
  numericCellStyle,
  manMonthValueFormatter,
} from './common'

// --- Resource group ---

export const resourceColumns: ColGroupDef<ProgramManagementRow> = {
  headerName: intl.formatMessage({ id: 'programManagement.column.resource' }),
  children: [
    {
      colId: 'resource.totalResource',
      headerName: intl.formatMessage({
        id: 'programManagement.column.resource.totalResource',
      }),
      width: 90,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'resource', 'totalResource')
      },
      cellStyle: numericCellStyle,
      valueFormatter: manMonthValueFormatter,
    },
    {
      colId: 'resource.investedResource',
      headerName: intl.formatMessage({
        id: 'programManagement.column.resource.investedResource',
      }),
      width: 100,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'resource', 'investedResource')
      },
      cellStyle: numericCellStyle,
      valueFormatter: manMonthValueFormatter,
    },
    {
      colId: 'resource.scheduledResource',
      headerName: intl.formatMessage({
        id: 'programManagement.column.resource.scheduledResource',
      }),
      width: 110,
      editable: false,
      valueGetter: (params: RowValueGetter) => {
        if (isProcessRow(params)) return null
        return getAggregatedValue(params, 'resource', 'scheduledResource')
      },
      cellStyle: numericCellStyle,
      valueFormatter: manMonthValueFormatter,
    },
  ],
}
